import { type QueryParams, updateQueryString } from './update_query_string';

type LocationOptions = {
  origin?: string;
  pathname?: string;
  search?: QueryParams;
};

export function makeUrl(
  location: LocationOptions = {},
  currentLocation = window.location,
) {
  const origin = location.origin ?? currentLocation.origin;
  const pathname = location.pathname ?? currentLocation.pathname;
  const search = location.search
    ? updateQueryString(currentLocation.search, location.search)
    : currentLocation.search;

  return `${origin}${pathname}${search}`;
}
